import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import router from '@@/router';
import { store } from '@@/store';
import { isEmbedded } from '@@/utils/embed';
import '@@/index.css';
import '@@/moment-setup.ts';

const embedded = isEmbedded();

// Le store n'utilise pas persistReducer en embed (cf. store.ts) : monter
// persistStore/PersistGate dessus n'aurait aucun effet utile.
const persistor = embedded ? null : persistStore(store);

// Active les surcharges d'overlays de index.css : dans l'iframe, `position:
// fixed` s'ancre sur toute la hauteur du contenu et non sur la zone visible.
if (embedded) {
  document.body.classList.add('is-embedded');
}

const app = (
  <>
    <Toaster
      containerStyle={
        embedded
          ? { top: 'calc(var(--embed-viewport-top, 0px) + 16px)' }
          : undefined
      }
    />
    <RouterProvider router={router} />
  </>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      {persistor ? (
        <PersistGate loading={null} persistor={persistor}>
          {app}
        </PersistGate>
      ) : (
        app
      )}
    </Provider>
  </React.StrictMode>,
);
